import { Link } from 'react-router';
import { CheckList } from '@/components/common/CheckList';
import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Button } from '@/components/ui/button';
import { GetStartedLink } from '@/constants/navigation';
import { Engagement } from '@/pages/Home/data';

const SectionId = 'engagement';
const TitleId = 'engagement-title';

export function EngagementSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId} tone="pad">
      <SectionHeading id={TitleId} title={Engagement.title} description={Engagement.description} />
      <ul className="mt-12 grid gap-6 lg:grid-cols-3">
        {Engagement.options.map((option) => (
          <li key={option.id} className="flex flex-col rounded-lg border border-grid bg-paper p-6 sm:p-8">
            <h3 className="text-xl font-bold text-graphite">{option.title}</h3>
            <p className="mt-2 leading-relaxed text-steel">{option.description}</p>
            <p className="mt-5 border-t border-grid pt-5 text-[0.9375rem] leading-relaxed text-graphite">
              <span className="font-semibold">{Engagement.bestForLabel}</span> {option.bestFor}
            </p>
            <CheckList items={option.includes} className="mt-5 text-[0.9375rem]" />
            <div className="mt-auto pt-8">
              <Button asChild variant="outline" className="w-full">
                <Link to={`${GetStartedLink.to}?engagement=${option.id}`}>
                  {GetStartedLink.label}
                  <span className="sr-only">, {option.title}</span>
                </Link>
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </PageSection>
  );
}